import PropTypes from 'prop-types';
import Button from '../../Button';
import Icon from '../../Icon';

const Body = (props) => {
  const { data, isEditMode } = props;
  const {
    label,
    href,
    align = 'center',
    variation,
    isCircle,
    openLinkInNewTab,
    icon,
  } = data;

  const hasLink = href?.[0];

  return (
    <div className={`button-block align-${align}`}>
      <Button
        href={isEditMode || !hasLink ? null : href?.[0]['@id']}
        openLinkInNewTab={openLinkInNewTab}
        label={label}
        primary={variation === 'primary'}
        circle={isCircle}
      >
        {icon && <Icon name={icon} />}
        {!isCircle && label}
      </Button>
    </div>
  );
};

Body.propTypes = {
  isEditMode: PropTypes.bool,
};

export default Body;
